import type { enUi } from "./en-ui";

export const deUi = {
  "ui.cheatCodeAccepted": "CHEAT-CODE AKZEPTIERT",
  "ui.accessingMassifDeepSpaceNetwork":
    "VERBINDE MIT MASSIF DEEP SPACE NETWORK...",
  "ui.640kMemoryOk": "640K SPEICHER OK",
  "ui.loadingScrumExe": "LADE SCRUM.EXE...",
  "ui.diskReadError": "LESEFEHLER",
  "ui.abortRetryFail": "ABBRECHEN, WIEDERHOLEN, AUFGEBEN?",
  "ui.loadingSectorArt": "LADE SEKTORGRAFIK...",
  "ui.retry": "WIEDERHOLEN",
  "ui.abort": "ABBRECHEN",
  "ui.soundOff": "Ton aus",
  "ui.soundOn": "Ton an",
  "ui.exit": "Beenden",
  "ui.fullscreen": "Vollbild",
  "ui.exitFullscreen": "Vollbild verlassen",
  "ui.hideControls": "Menü ausblenden",
  "ui.showControls": "Menü anzeigen",
  "ui.language": "Sprache",
  "ui.continue": "Fortsetzen",
  "ui.newGame": "Neues Spiel",
  "ui.more": "Weiter...",
  "ui.textSpeed": "TEXTTEMPO",
  "ui.mancomb": "Mancomb",
  "ui.useWith": "{item} mit {target} benutzen",
} satisfies Record<keyof typeof enUi, string>;
